export default __webpack_public_path__ + "static/about-us-box-c30bbfb9d0a4e497841bfa669f5d06b4.png";